// Mock data for LadyGo VTC website

export const services = [
  {
    id: 1,
    title: "Transferts aéroport & gare",
    description: "Aéroport de Nantes-Atlantique, gares SNCF de Vannes et Nantes. Suivi de vol, accueil personnalisé, prise en charge des bagages."
  },
  {
    id: 2,
    title: "Déplacements d'affaires",
    description: "Rendez-vous professionnels, salons, meetings entre Vannes et Nantes. Ponctualité garantie et confidentialité absolue."
  },
  {
    id: 3,
    title: "Événements & soirées",
    description: "Mariage, gala, dîner, théâtre, opéra. Un chauffeur dédié pour une soirée en toute sérénité."
  },
  {
    id: 4,
    title: "Service au féminin",
    description: "Une attention particulière portée aux passagères : accompagnement rassurant, écoute et bienveillance."
  },
  {
    id: 5,
    title: "Mise à disposition",
    description: "Réservez votre chauffeur à l'heure ou à la journée pour vos déplacements successifs sur mesure."
  },
  {
    id: 6,
    title: "Longue distance",
    description: "Trajets intervilles depuis le Morbihan et la Loire-Atlantique, vers toute la France. Voyagez à votre rythme."
  }
];

export const testimonials = [
  {
    id: 1,
    text: "Un service impeccable avec Sab. Je me sens en sécurité et respectée à chaque trajet. Le petit plus féminin fait toute la différence — je ne prends plus que LadyGo.",
    author: "Sophie L.",
    role: "Cliente régulière"
  },
  {
    id: 2,
    text: "Pour mes déplacements professionnels, LadyGo est devenu indispensable. Ponctualité irréprochable, discrétion parfaite, et un accueil chaleureux.",
    author: "Camille R.",
    role: "Chef d'entreprise"
  },
  {
    id: 3,
    text: "Transferts aéroport toujours parfaits. On me suit, on m'attend, on porte mes bagages. Un vrai luxe qui fait gagner un temps précieux.",
    author: "Émilie D.",
    role: "Voyage d'affaires"
  },
  {
    id: 4,
    text: "Le jour J, tout était parfait : véhicule sublime, ponctualité à la minute et une attention rare de Sab. Merci pour cette prestation d'exception !",
    author: "Julie M.",
    role: "Mariée 2025"
  },
  {
    id: 5,
    text: "Une soirée sans stress, avec Sab attentive et discrète. LadyGo, c'est vraiment l'art du transport avec une touche féminine unique.",
    author: "Nathalie P.",
    role: "Soirée gala"
  },
  {
    id: 6,
    text: "Je recommande les yeux fermés. Élégance, professionnalisme et cette petite étincelle qui rend le trajet agréable. Bravo LadyGo !",
    author: "Élise B.",
    role: "Cliente fidèle"
  },
  {
    id: 7,
    text: "Un service haut de gamme à chaque fois. La ponctualité, la discrétion et l'élégance sont au rendez-vous. LadyGo, c'est la référence du VTC au féminin.",
    author: "Marine T.",
    role: "Cliente VIP"
  }
];

export const pricingPlans = [
  {
    id: 1,
    title: "Transfert",
    category: "Aéroport & gare",
    price: "Sur devis",
    features: [
      "Prise en charge à domicile",
      "Suivi de vol / train inclus",
      "Attente & bagages compris",
      "Bouteille d'eau offerte"
    ],
    popular: false
  },
  {
    id: 2,
    title: "Mise à disposition",
    category: "À l'heure",
    price: "60€ / h",
    pricePrefix: "à partir de",
    features: [
      "Chauffeur dédié",
      "Trajets illimités",
      "Idéal shopping, RDV, événements",
      "Minimum 2 heures"
    ],
    popular: true
  },
  {
    id: 3,
    title: "Longue distance",
    category: "Sur devis",
    price: "1,50€ / km",
    pricePrefix: "à partir de",
    features: [
      "Trajets intervilles & Europe",
      "Confort premium",
      "Devis en 24h",
      "Paiement flexible"
    ],
    popular: false
  }
];

export const contactInfo = {
  phone: "06 11 70 99 73",
  phoneFormatted: "+33611709973",
  email: "ladygo.vtc@gmail.com",
  whatsapp: "33611709973",
  availability: "Sur réservation",
  zone: "Vannes (Morbihan) & Nantes (Loire-Atlantique)",
  zoneDetails: "Grand Ouest & longue distance sur devis",
  siren: "801 419 557 00039",
  company: "Entreprise VTC agréée"
};